const SITE_URL = 'https://superbuysheet.lol';
const LOGO_URL = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67defc9f4dfae2c04004e8ea78b88107.png';

export const homeSchemaOrg = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'SuperBuySheet',
    url: SITE_URL,
    logo: LOGO_URL,
    description: 'Superbuy Spreadsheet resource hub helping international shoppers discover, compare, and shop smarter.',
    sameAs: [
      'https://kaspreadsheet.com',
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'SuperBuySheet',
    url: SITE_URL,
    description: 'The ultimate Superbuy Spreadsheet resource center — product finds, QC guides, shipping tutorials, and expert shopping tips.',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${SITE_URL}/search?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'What is Superbuy Spreadsheet?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Superbuy Spreadsheet is a powerful shopping research tool that helps international buyers discover products, compare options, organize their favorite finds, and make smarter purchasing decisions through organized spreadsheet resources.',
        },
      },
      {
        '@type': 'Question',
        name: 'Why use Superbuy Spreadsheet?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Superbuy Spreadsheet helps you discover better products, save research time, compare before buying, and shop with confidence through structured, community-curated product data.',
        },
      },
      {
        '@type': 'Question',
        name: 'How does Superbuy Spreadsheet work?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Find products from curated spreadsheet categories, compare product information across columns, check QC guidance from community reviews, and complete purchases through Superbuy with confidence.',
        },
      },
      {
        '@type': 'Question',
        name: 'Is Superbuy Spreadsheet safe?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes. SuperBuySheet is an educational resource that does not sell products, process payments, or collect financial information. Always verify sellers and product information before purchasing.',
        },
      },
    ],
  },
];